var render = function render(){var _vm=this,_c=_vm._self._c;return _c('strong',[_vm._v("SAP")])
}
var staticRenderFns = []

export { render, staticRenderFns }